module.exports = __webpack_public_path__ + "img/title.49e9769f.png";